import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { faDownload, faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ChartsKho from "./ChartsKho";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import Search from "./Search";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import TableContainer from "./table";

export default function ThongKeKhoByName() {
  const { lang, proxy } = useSelector((state) => state);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [searchDate, setSearchDate] = useState({ from: "", to: "" });
  const [tempValue, setTempValue] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState({
    label: "Kho Hải Phòng",
    value: "HP",
  });

  const [kho, setKho] = useState([
    { label: "Kho Hải Phòng", value: "HP" },
    { label: "Kho Phúc Long - Ninh Bình", value: "PL" },
    { label: "Kho Cửa Lò - Nghệ An", value: "CL" },
  ]);

  useEffect(() => {
    const params = new URLSearchParams();

    if (search?.from) params.set("from", search.from);
    if (search?.to) params.set("to", search.to);

    if (Object.values(search).length > 0) {
      Swal.fire({
        title: lang["searching"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    const fetchData = async () => {
      setLoading(true);
      await fetch(
        `${proxy()}/api/stats/PhanPhoiVungMienTheoSanPham?${params.toString()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...search, type: selectedValue.value }),
        }
      )
        .then((res) => res.json())
        .then((reps) => {
          const { mapped_result } = reps;
          setData(mapped_result);
        })
        .finally(() => {
          setLoading(false);
          // setLoadingNhaMay(false);
          // setLoadingKhoThue(false);
          Swal.close();
        });
    };
    fetchData();
  }, [search, refresh, searchDate, selectedValue]);

  const handleSearch = () => {
    setSearch(tempValue);
  };
  const formmatDate = (date) => {
    return moment(date).format("MM-DD-YYYY");
  };

  const handleChange = (key, values) => {
    setTempValue((prev) => {
      const newPrev = { ...prev };

      if (key === "from" || key === "to") {
        newPrev[key] = values ? formmatDate(values) : "";
      } else if (Array.isArray(values) && values.length) {
        newPrev[key] = values.map((item) => item.value);
      } else {
        delete newPrev[key];
      }

      return newPrev;
    });
  };

  // if (loading) {
  //   return (
  //     <img
  //       width={40}
  //       className="loading-image"
  //       src="/images/icon/load.gif"
  //       alt="Loading..."
  //       style={{
  //         position: "absolute",
  //         top: "50%",
  //         left: "55%",
  //         transform: "translate(-50%, -50%)",
  //         zIndex: 2,
  //       }}
  //     />
  //   );
  // }

  return (
    <div className="container-fluid">
      <div className="row" style={{ margin: "5px -15px" }}>
        <div className="col-md-12">
          <div className="white_shd full">
            <div className="tabbar padding_infor_info_p-d-5">
              <div
                className="row mt-3 mb-3"
                style={{
                  margin: "0 -15px",
                }}
              >
                <Search
                  lang={lang}
                  refresh={refresh}
                  setSearch={setSearch}
                  setRefresh={setRefresh}
                  setTempValue={setTempValue}
                  handleSearch={handleSearch}
                  handleChange={handleChange}
                  tempValue={tempValue}
                  searchDate={searchDate}
                  setSearchDate={setSearchDate}
                />

                <KhoContainer
                  data={data}
                  setData={setData}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  loading={loading}
                  setLoading={setLoading}
                  kho={kho}
                />

                {/* <ThongKeNhaMay
                  data={ThongKeNM}
                  lang={lang}
                  setSearch={setSearch}
                  setRefresh={setRefresh}
                  loading={loadingNhaMay}
                  setLoading={setLoadingNhaMay}
                />
                <ThongKeKhoThue
                  data={ThongKeKT}
                  lang={lang}
                  setSearch={setSearch}
                  setRefresh={setRefresh}
                  loading={loadingKhoThue}
                  setLoading={setLoadingKhoThue}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const KhoContainer = ({
  data,
  // setData,
  selectedValue,
  setSelectedValue,
  loading,
  setLoading,
  setRefresh,
  kho,
}) => {
  const categories = data.map((item) => item?.SP);

  const series = [
    {
      name: "SL Cần Xuất",
      data: data.map((item) => ({
        x: `${item.MaSP}\n${item.TenSP}`,
        y: item.PhanPhoiCanXuat?.Bao || 0,
        bao: item.PhanPhoiCanXuat?.Bao || 0,
        tan: item?.PhanPhoiCanXuat?.Tan || 0,
      })),
    },
    {
      name: "SL Xuất Thực Tế",
      data: data.map((item) => ({
        x: `${item.MaSP}\n${item.TenSP}`,
        y: item.PhanPhoiThucTe.Bao || 0,
        bao: item.PhanPhoiThucTe.Bao || 0,
        tan: item?.PhanPhoiThucTe?.Tan || 0,
      })),
    },
    {
      name: "SL Hệ Thống Ghi Nhận",
      data: data.map((item) => ({
        x: `${item.MaSP}\n${item.TenSP}`,
        y: item.PhanPhoiGhiNhan?.Bao || 0,
        bao: item.PhanPhoiGhiNhan?.Bao || 0,
        tan: item.PhanPhoiGhiNhan?.Tan || 0,
      })),
    },
    {
      name: "SL Chênh Lệch",
      data: data.map((item) => ({
        x: `${item.MaSP}\n${item.TenSP}`,
        y: item.DongBaoChenhLech || 0,
        bao: item.DongBaoChenhLech || 0,
        tan: (item.DongBaoChenhLech * item.TrongLuong) / 1000 || 0,
      })),
    },
    {
      name: "Tỉ Lệ",
      data: data.map((item) => ({
        x: `${item.MaSP}\n${item.TenSP}`,
        y: item.TiLe || 0,
        bao: item.TiLe || 0,
        tile: item?.TiLe || 0,
      })),
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    xaxis: {
      categories,
      labels: {
        style: { fontFamily: "UTM Avo, sans-serif" },
        formatter: (value) => {
          console.log("value", value);
          let pairs = [];
          const l = 3;
          if (typeof value === "string") {
            let len = value.split(" ");
            for (let i = 0; i < len.length; i += l) {
              let chunk = len.slice(i, i + l).join(" ");
              pairs.push(chunk);
            }
            return pairs;
          }
          return value;
        },
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        colors: ["#304758"],
      },
      formatter: function (val, opts) {
        const { bao, tan } =
          opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
        return bao;
      },
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          const { bao, tan, tile } =
            opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
          const value = tile ? `${tile}%` : `${bao} Bao\n${tan} Tấn`;
          return value.replace(/\n/g, "<br/>");
        },
      },
      hideEmptySeries: true,
    },
    colors: [
      "#008ffb",
      "#775DD0",
      "#feb019",
      "#FF4560",
      "#00e396",
      "#546E7A",
      "#662E9B",
      "#33b2df",
      "#d4526e",
    ],
    series,
  };

  const headers = [
    { label: "Mã Thành Phẩm", rowSpan: 2, colSpan: 1 },
    { label: "Tên Thành Phẩm", rowSpan: 2, colSpan: 1 },
    // { label: "LOT", rowSpan: 2, colSpan: 1 },
    // { label: "Lệnh Sản Xuất", rowSpan: 2, colSpan: 1 },
    {
      label: "SL cần xuất",
      child: [
        { label: "Xuất kho (Bao)", rowSpan: 1, colSpan: 1 },
        { label: "Xuất kho (Tấn)", rowSpan: 1, colSpan: 1 },
      ],
    },
    {
      label: "SL thực tế/người dùng nhập vào",
      child: [
        { label: "Xuất kho (Bao)", rowSpan: 1, colSpan: 1 },
        { label: "Xuất kho (Tấn)", rowSpan: 1, colSpan: 1 },
      ],
    },
    {
      label: "SL hệ thống ghi nhận",
      child: [
        { label: "Xuất kho (Bao)", rowSpan: 1, colSpan: 1 },
        { label: "Xuất kho (Tấn)", rowSpan: 1, colSpan: 1 },
      ],
    },
    { label: "SL chênh lệch (Bao)", rowSpan: 2, colSpan: 1 },
    { label: "Tỉ lệ", rowSpan: 2, colSpan: 1 },
  ];
  return (
    <>
      <div className="__table col-sm-12 mt-2">
        <div
          className="card"
          style={{
            borderRadius: "0.25rem",
            // boxShadow:
            //   "rgba(0, 0, 0, 0.125) 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 1px 3px",
          }}
        >
          <div className="card-header _title d-flex justify-content-end align-items-center title mb-2">
            <h5
              className="w-100"
              style={{
                color: "#44a1a1",
                fontSize: "18px",
                padding: "6px 0px",
              }}
            >
              THỐNG KÊ {selectedValue?.label}
            </h5>
            <select
              className="form-select form-control mr-2"
              style={{ width: "fit-content" }}
              onChange={(e) => {
                const selected = kho.find(
                  (item) => item.label === e.target.value
                );
                setSelectedValue(selected);
              }}
            >
              {kho.map((item, index) => (
                <option key={index} value={item.label}>
                  {item.label}
                </option>
              ))}
            </select>

            <FontAwesomeIcon
              className="pointer mr-2"
              icon={faRetweet}
              fontSize={27}
              color="rgb(224, 118, 42)"
              onClick={() => {
                setRefresh((prev) => prev + 1);
              }}
            />
            <FontAwesomeIcon
              className="pointer"
              icon={faDownload}
              fontSize={27}
              color="#269c1b"
              onClick={() => exportStyledExcel(data, selectedValue?.label)}
            />
          </div>
          {/* <div className={loading && `text-center align-items-center`}> */}
          {/* {loading ? (
              <img
                width={35}
                className="mb-1"
                src="/images/icon/load.gif"
                alt="Loading..."
              />
            ) : ( */}
          {/* <ChartsKho data={chartOptions} /> */}
          <TableContainer headers={headers} data={data} loading={loading} />
          {/* )} */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

const exportStyledExcel = (data, name) => {
  const header = [
    [
      "Mã Thành Phẩm",
      "Tên Thành Phẩm",
      "SL cần xuất",
      null,
      "SL xuất thực tế/người dùng nhập vào",
      null,
      "SL hệ thống ghi nhận",
      null,
      "SL chênh lệch",
      "Tỉ lệ",
    ],
    [
      "",
      "",
      "Xuất kho (Tấn)",
      "Xuất kho (Bao)",
      "Xuất kho (Tấn)",
      "Xuất kho (Bao)",
      "Xuất kho (Tấn)",
      "Xuất kho (Bao)",
      "",
      "",
    ],
  ];

  const body = data.map((item) => [
    item.MaSP,
    item.TenSP,
    item.PhanPhoiCanXuat.Tan || 0,
    item.PhanPhoiCanXuat.Bao || 0,
    item.PhanPhoiThucTe.Tan || 0,
    item.PhanPhoiThucTe.Bao || 0,
    item.PhanPhoiGhiNhan.Tan || 0,
    item.PhanPhoiGhiNhan.Bao || 0,
    item.DongBaoChenhLech || 0,
    (item.TiLe || 0) + "%",
  ]);

  const total = [
    "",
    "",
    "",
    data.reduce((sum, i) => sum + i.PhanPhoiCanXuat.Bao, 0),
    "",
    data.reduce((sum, i) => sum + i.PhanPhoiThucTe.Bao, 0),
    "",
    data.reduce((sum, i) => sum + i.PhanPhoiGhiNhan.Bao, 0),
    data.reduce((sum, i) => sum + i.DongBaoChenhLech, 0),
  ];

  const wsData = [...header, ...body, total];
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Merge header
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
    { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
    { s: { r: 0, c: 2 }, e: { r: 0, c: 3 } },
    { s: { r: 0, c: 4 }, e: { r: 0, c: 5 } },
    { s: { r: 0, c: 6 }, e: { r: 0, c: 7 } },
    { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } },
    { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } },
  ];

  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];
      if (cell) {
        cell.s = {
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
        };
        if (R < 2) {
          cell.s = {
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
            font: { bold: true },
          };
        }
        if (R === range.e.r) {
          cell.s.font = { bold: true };
          cell.s.fill = {
            patternType: "solid",
            fgColor: { rgb: "ffff00" },
          };
        }
      }
    }
  }

  ws["!cols"] = [
    { wch: 15 }, // Mã Thành Phẩm
    { wch: 40 }, // Tên Thành Phẩm
    { wch: 15 }, // LOT
    { wch: 20 }, // Lệnh sản xuất
    { wch: 15 }, // Đóng bao (Tấn)
    { wch: 15 }, // Đóng bao (Bao)
    { wch: 15 }, // Ghi nhận (Tấn)
    { wch: 15 }, // Ghi nhận (Bao)
    { wch: 15 }, // SL chênh lệch
    { wch: 10 }, // Tỉ lệ
  ];
  function getFormattedDateTime() {
    const now = new Date();

    const pad = (n) => (n < 10 ? "0" + n : n);

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear();

    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day}_${hours}H${minutes}`;
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, `DATA_Thống Kê`);

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    `DATA_Thống Kê ${name}_${getFormattedDateTime()}.xlsx`
  );
};
